import React from 'react';
import InstitutionFooter from '../../FinancialInstitution/Footer';
import { cn } from '../../../../../utils/styles';
import Icons from '../../../../../components/Common/Icons/Icons';

interface DirectAuthLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  contentClassName?: string;
}

function DirectAuthLayout({ children, className, contentClassName, ...props }: DirectAuthLayoutProps) {
  return (
    <div
      className={cn([
        'guidance w-screen min-h-screen bg-primary-foreground',
        'bg-gradient-to-b from-white via-blue-100 to-white',
        className,
      ])}
      {...props}
    >
      <div className="text-xl bg-addition1 text-white">
        <div className="m-auto max-w-6xl flex gap-2 items-center h-20 px-4">
          <Icons.GuidanceLogo width={36} height={36} />
          <div className="flex gap-0.5">
            <span className="font-light">Guidance</span>
          </div>
        </div>
      </div>

      <div className={cn('min-h-[calc(100vh-64px-58px-48px)] md:min-h-[81vh]', contentClassName)}>{children}</div>

      <InstitutionFooter />
    </div>
  );
}

DirectAuthLayout.defaultProps = {
  contentClassName: undefined,
};

export default DirectAuthLayout;
